import MyAxios from '../utils/instance.js'
const getuserName = {
	// 获取用户信息
	Getnames(id) {
	    return MyAxios({
	      url: `/toUser//getUserById/${id}`,
	    })
	  },
}
export default getuserName